import { render, staticRenderFns } from "./SwitchHistory.vue?vue&type=template&id=10422314&scoped=true&"
import script from "./SwitchHistory.vue?vue&type=script&lang=js&"
export * from "./SwitchHistory.vue?vue&type=script&lang=js&"
import style0 from "./SwitchHistory.vue?vue&type=style&index=0&id=10422314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10422314",
  null
  
)

export default component.exports